import { ArchiveClockIcon } from './ArchiveClockIcon';

/**
 * author: Colton Wiscombe
 * id 8DBB6350-60C3-4433-9805-C8AB712950C4
 * name archive-clock
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-clock.svg
 * tags
 * - Date / Time 
 */
export const BoxClockIcon = ArchiveClockIcon;
export default BoxClockIcon